import {HTTP} from "@/http";

export const state = {
    loading: false,
    errors: [],
    token: localStorage.getItem("token")
}
export const getters = {
    httpLoading: state => state.loading,
    httpErrors: state => state.errors
}
export const actions = {

    async generateManualOrderStatement({commit}, selectedOrders) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/orders/generate-statement`, selectedOrders, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateOrderInvoice({commit}, orderId) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.get(`app/orders/generate-invoice/${orderId}`, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateDeliveryNote({commit}, orderId) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.get(`app/orders/generate-delivery-note/${orderId}`, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateCustomersReport({commit}) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/customer-report`,'',{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateStockReport({commit}) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/stock-report`,'',{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateShipmentsReport({commit}, dates) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/shipments-report`,dates,{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateStockAdjustmentReport({commit}, dates) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/stock-adjustment-report`,dates,{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateOrderSalesReport({commit}, dates) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/sales-report`,dates,{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateSampleOrdersReport({commit}, dates) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/sample-orders-report`,dates,{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateCancelledOrdersReport({commit}, dates) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/cancelled-orders-report`,dates,{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateSalesPerformanceData({commit}, period) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.get(`app/reports/sales-performance/${period}`)
                .then(response => {
                    return response.data
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateBatchOrderInvoices({commit}, orderIds) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/orders/generate-invoices`, {'order_ids': orderIds}, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateBatchOrderDeliveryNotes({commit}, orderIds) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/orders/generate-delivery-notes`, {'order_ids': orderIds}, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateCreditNotePdf({commit}, creditNoteId) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.get(`app/orders/generate-credit-note/${creditNoteId}`, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateCreditNotesReport({commit}, data) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/credit-notes-report`,data, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async uploadProductImage({commit}, data) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/inventory/upload-image`, data)
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async fetchSalesPerformanceFilters({commit}) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.get(`app/reports/filtered-sales-performance/filters`)
                .then(response => {
                    return response.data
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateFilteredSalesReport({commit}, data) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/filtered-sales-performance`, data)
                .then(response => {
                    return response.data
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateStockMovementReport({commit}, dates) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/reports/stock-report/historical`, dates, {responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    },

    async generateOffshoreOrdersForDelivery({commit}, date) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            return await HTTP.post(`app/orders/generate-orders-for-collection/v1`,date,{responseType: "blob"})
                .then(response => {
                    return response
                })
        } catch (e) {
            console.log('errors', e)
            commit('SET_ERRORS', e)
        } finally {
            commit('LOADING_FALSE')
        }
    }
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}
